import React, { useState } from 'react';

const LandingPage = ({ onLoginSuccess, onContinueAsGuest }) => {
  const [token, setToken] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!token || submitting) return;

    setSubmitting(true);
    setError(null);

    try {
      const apiUrl = process.env.REACT_APP_API_URL || '';
      const response = await fetch(`${apiUrl}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        // `token` is sent exactly as typed/pasted -- no trimming or
        // normalization, since login must be an exact match.
        body: JSON.stringify({ token }),
      });

      const body = await response.json().catch(() => ({}));

      if (!response.ok) {
        setError(body.error || 'We could not log you in.');
        return;
      }

      onLoginSuccess(body.session_token);
    } catch (requestError) {
      setError('We could not reach the server. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="landing-shell">
      <div className="landing-panel">
        <div>
          <h1>Value, made visible.</h1>
          <p>Log in with your access token, or continue without logging in.</p>
        </div>

        <form onSubmit={handleSubmit} noValidate>
          <div className="landing-field">
            <label htmlFor="landing-token">Access token</label>
            <input
              id="landing-token"
              name="token"
              type="password"
              autoComplete="off"
              autoCapitalize="off"
              autoCorrect="off"
              spellCheck={false}
              className="landing-token-input"
              value={token}
              onChange={(event) => setToken(event.target.value)}
              placeholder="Paste your access token"
            />
          </div>

          {error && (
            <div className="status-panel error-panel" role="alert">
              <span className="status-icon">!</span>
              <div>
                <strong>Couldn&rsquo;t log you in</strong>
                <p>{error}</p>
              </div>
            </div>
          )}

          <button
            type="submit"
            className="landing-submit-button"
            disabled={submitting || !token}
          >
            {submitting ? 'Logging in…' : 'Log in'}
          </button>
        </form>

        <div className="landing-divider">or</div>

        <button
          type="button"
          className="landing-guest-button"
          onClick={onContinueAsGuest}
        >
          Continue without logging in
        </button>
      </div>
    </main>
  );
};

export default LandingPage;
